<script setup lang="ts">
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import { setPageTitle } from '@/@core/utils/pageMetaUtils'
import ForgotPasswordForm from '@/components/Auth/ForgotPasswordForm.vue'

setPageTitle(PageMeta.Auth.forgotPassword.title)
definePage({ meta: PageMeta.Auth.forgotPassword.meta })
</script>

<template>
  <ForgotPasswordForm />
</template>
